import { render } from "./policy-news.vue?vue&type=template&id=61d29666&scoped=true"
import script from "./policy-news.vue?vue&type=script&lang=js"
export * from "./policy-news.vue?vue&type=script&lang=js"

import "./policy-news.vue?vue&type=style&index=0&id=61d29666&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d29666"]])

export default __exports__